import type { ReactNode } from 'react';
import { Empty } from 'antd';

interface EmptyStateProps {
  /** Main message; defaults to a generic "no data" line. */
  description?: ReactNode;
  /** Optional action (e.g. a button) shown under the message. */
  children?: ReactNode;
}

/** Shared empty state for empty queues, insufficient data, or unloaded script/KB content. */
export default function EmptyState({ description = 'داده‌ای برای نمایش وجود ندارد', children }: EmptyStateProps) {
  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} style={{ padding: '48px 0' }}>
      {children}
    </Empty>
  );
}
